import { render } from "./NotificationLog.vue?vue&type=template&id=583fc508"
import script from "./NotificationLog.vue?vue&type=script&lang=ts"
export * from "./NotificationLog.vue?vue&type=script&lang=ts"
script.render = render

export default script